"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _defaultTheme = _interopRequireDefault(require("../../defaultTheme"));

var _ChevronRight = _interopRequireDefault(require("../../icons/ChevronRight"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var StyledBreadcrumbsItem = _styledComponents.default.li.withConfig({
  displayName: "BreadcrumbsItem__StyledBreadcrumbsItem",
  componentId: "sc-1aqqbs7-0"
})(["display:flex;align-items:center;"]);

var StyledBreadcrumbsItemAnchor = (0, _styledComponents.default)(function (_ref) {
  var active = _ref.active,
      Component = _ref.component,
      children = _ref.children,
      theme = _ref.theme,
      props = _objectWithoutProperties(_ref, ["active", "component", "children", "theme"]);

  return React.createElement(Component, props, children);
}).withConfig({
  displayName: "BreadcrumbsItem__StyledBreadcrumbsItemAnchor",
  componentId: "sc-1aqqbs7-1"
})(["font-weight:", ";color:", ";text-decoration:none;transition:color ", " ease-in-out;&:hover,&:focus{color:", ";outline:none;text-decoration:underline;}"], function (_ref2) {
  var active = _ref2.active,
      theme = _ref2.theme;
  return active && theme.orbit.fontWeightBold;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.orbit.paletteInkLight;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.orbit.durationFast;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.orbit.paletteInkLightHover;
});
StyledBreadcrumbsItemAnchor.defaultProps = {
  theme: _defaultTheme.default
};
var StyledBreadcrumbsItemIcon = (0, _styledComponents.default)(_ChevronRight.default).withConfig({
  displayName: "BreadcrumbsItem__StyledBreadcrumbsItemIcon",
  componentId: "sc-1aqqbs7-2"
})(["margin:0 ", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.orbit.spaceXSmall;
});
StyledBreadcrumbsItemIcon.defaultProps = {
  theme: _defaultTheme.default
};

var BreadcrumbsItem = function BreadcrumbsItem(_ref7) {
  var active = _ref7.active,
      children = _ref7.children,
      dataTest = _ref7.dataTest,
      onClick = _ref7.onClick,
      contentKey = _ref7.contentKey,
      _ref7$component = _ref7.component,
      component = _ref7$component === void 0 ? function (props) {
    return React.createElement("a", props);
  } : _ref7$component,
      props = _objectWithoutProperties(_ref7, ["active", "children", "dataTest", "onClick", "contentKey", "component"]);

  return React.createElement(StyledBreadcrumbsItem, {
    "data-test": dataTest,
    "aria-current": active ? "page" : undefined,
    property: "itemListElement",
    typeof: "ListItem"
  }, React.createElement(StyledBreadcrumbsItemAnchor, _extends({
    component: component,
    active: active,
    onClick: onClick,
    property: "item",
    typeof: "WebPage"
  }, props), React.createElement("span", {
    property: "name"
  }, children)), React.createElement("meta", {
    property: "position",
    content: contentKey
  }), !active && React.createElement(StyledBreadcrumbsItemIcon, {
    ariaHidden: true,
    size: "small",
    color: "tertiary"
  }));
};

var _default = BreadcrumbsItem;
exports.default = _default;